import {
  GET_GETSTARTED,
  GET_GETSTARTEDS,
  GETSTARTED_ERROR,
  DELETE_GETSTARTED,
  ADD_GETSTARTED,
  UPDATE_GETSTARTED
} from '../actions/types';

const initialState = {
  getStarted: null,
  getStarteds: [],
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_GETSTARTED:
      return {
        ...state,
        getStarted: payload.info,
        loading: false
      };
    case GET_GETSTARTEDS:
      return {
        ...state,
        getStarteds: payload.info,
        loading: false
      };
    case ADD_GETSTARTED:
      return {
        ...state,
        getStarteds: [payload, ...state.getStarteds],
        loading: false
      };
    case UPDATE_GETSTARTED:
      return {
        ...state,
        getStarteds: state.getStarteds.map(item => 
          item._id === payload._id ? payload : item
        ),
        getStarted: payload,
        loading: false
      };
    case DELETE_GETSTARTED:
      return {
        ...state,
        getStarteds: state.getStarteds.filter(item => item._id !== payload),
        loading: false
      };
    case GETSTARTED_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
} 